module.exports = __webpack_public_path__ + "static/img/side_logo_max_yqzx.4c798845.png";